import * as React from 'react';
import { convertToCurrency } from '../../utils/numberConverter';

interface INetContributionProps {
    netContribution: string
}

const NetContribution: React.FC<INetContributionProps> = ({netContribution}) => {
    if (!netContribution) return;
    return (
        <div className='net-contribution-data org-container'>
            <span style={{color: 'red', fontWeight: 'bold', width: "100%", fontSize: "16px"}}>Net Contribution</span>
            <span style={{fontWeight: "bold", fontSize: "16px"}}>{convertToCurrency(Number.parseInt(netContribution), 0)}</span>
        </div>
    );
};

export const NetContributionData = React.memo(NetContribution);